import { Directive, ElementRef, Renderer2, HostListener, Inject, PLATFORM_ID, Input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Directive({
    selector: '[sticky]'
})
export class StickyDirective {
    private _el: HTMLElement;
    private footer;
    private alert;
    @Input('header') header;
    width;
    height;
    @Input() activeTab;
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
    }
    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(
                () => {
                    this._el = this.el.nativeElement;
                    this.footer = document.getElementsByTagName('footer-component')[0];
                    this.width = this._el.clientWidth;
                    this.height = this._el.parentElement.clientHeight;
                }, 1000
            )
        }
    }

    ngOnChanges(changes) {
        if (changes.activeTab && this._el) {
            setTimeout(
                ()=>{
                    this.height = this._el.parentElement.clientHeight;
                },500
            )
        }
    }

    @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
        if (isPlatformBrowser(this.platformId)) {
            var window_top = window.scrollY;
            // let currentScrollPos = window.pageYOffset;
            // let navorders=0;
            // if (this.prevScrollpos >= currentScrollPos) {
            //     navorders=70;
            // } else {
            //     navorders=0;
            // }
            // this.prevScrollpos = currentScrollPos;
            if (this.footer) {
                var footer_top = this.footer.offsetTop;
                var div_top = this._el.parentElement.parentElement.offsetTop;
                let mtop = (this.header) ? this.header : 0;
                if (window_top + this.height + mtop > footer_top) {
                    this._el.removeAttribute("style");
                    this.renderer.setStyle(this._el, "position", "absolute");
                    this.renderer.setStyle(this._el, "bottom", 0);
                    this.renderer.setStyle(this._el, "width", this.width + "px");
                }
                else
                    if (window_top + mtop > div_top) {
                        let top = mtop;
                        this._el.removeAttribute("style");
                        this.renderer.setStyle(this._el, "position", "fixed");
                        this.renderer.setStyle(this._el, "z-index", 1);
                        this.renderer.setStyle(this._el, "top", top + "px");
                        this.renderer.setStyle(this._el, "width", this.width + "px");
                        this.renderer.setStyle(this._el, "height", this.height + "px");
                    }
                    else {
                        this._el.removeAttribute("style");
                    }
            }
        }
    }
}